export const passepartoutSecurityKey = process.env.VUE_APP_PASSEPARTOUT_SECURITY_KEY || '';
export const studentsPicturesBucket = process.env.VUE_APP_STUDENTS_PICTURES_BUCKET;
export const saraivaId = process.env.VUE_APP_SARAIVA_ID;
export const westerosReactionsSource = process.env.VUE_APP_WESTEROS_REACTIONS_SOURCE;
export const maxAttemptsPracticeActivity = 3;
export const ugNewEvaluationWeightsStart = process.env.VUE_APP_UG_NEW_EVALUATION_WEIGHTS_START;
export const ugCurrentEnrollmentWindowStart =
  process.env.VUE_APP_UG_CURRENT_ENROLLMENT_WINDOW_START;
export const ugCurrentEnrollmentWindowEnd = process.env.VUE_APP_UG_CURRENT_ENROLLMENT_WINDOW_END;
export const ugEnrollmentDetailedGradesReleaseStart =
  process.env.VUE_APP_UG_ENROLLMENT_DETAILED_GRADES_RELEASE_START;
export const equalWebSiteKey = 'aecf6ffe12fa1c1d26fe0ed3b1d39c4a';
export const equalWebIntegrityKey =
  'sha512-5JFUorutIyGmP61zRJjdTke6AFi8/IYzJ6pyQL0UpUqwMNDuukmNH2qv2s+lj0X6MPtblMt4KgWLoDmqrTa5kg==';
export const finalAssessmentsLink = process.env.VUE_APP_FINAL_EXAMS;
export const descomplicaLandingUrl = process.env.VUE_APP_DESCOMPLICA_LANDING_URL;
export const DESCOMPLICA_SUPPORT_MANUAL_URL = process.env.VUE_APP_SUPPORT_MANUAL_URL;
export const googleFormStudentWorkabilitySurvey = String(
  process.env.VUE_APP_GOOGLE_FORM_STUDENT_WORKABILITY_SURVEY,
);
export const googleFormStudentSocioEconomicSurvey = String(
  process.env.VUE_APP_GOOGLE_FORM_STUDENT_SOCIOECONOMIC_SURVEY,
);
